import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {MainMenuPage} from './main-menu.page';

const mainMenuRoutes: Routes = [
    {
        path: '',
        component: MainMenuPage,
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(mainMenuRoutes)
    ],
    declarations: [MainMenuPage]
})
export class MainMenuPageModule {
}
